import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { resolveEnvironmentNotchLabel } from "@runcheetah/shared";
import { EnvironmentNotch } from "@runcheetah/ui";

import { AdminLayout } from "@/layouts/admin-layout";
import { BrandsPage } from "@/pages/brands";
import { BrandDetailsPage } from "@/pages/brand-details";
import { BillingPlansPage } from "@/pages/billing-plans";
import { CampaignsPage } from "@/pages/campaigns";
import { CampaignDetailPage } from "@/pages/campaign-detail";
import { CampaignPlannedPostDetailPage } from "@/pages/campaign-planned-post-detail";
import { CalendarOpsPage } from "@/pages/calendar-ops";
import { CarouselFormatsPage } from "@/pages/carousel-formats";
import { CreditPacksPage } from "@/pages/credit-packs";
import { UsersPage } from "@/pages/users";
import { UserDetailsPage } from "@/pages/user-details";
import { WorkspacesPage } from "@/pages/workspaces";
import { WorkspaceDetailsPage } from "@/pages/workspace-details";
import { LoginPage } from "@/pages/login";
import { RunsPage } from "@/pages/runs";
import { RuntimeFlagsPage } from "@/pages/runtime-flags";
import { ReleaseAccessPage } from "@/pages/release-access";
import { SocialPostPlannerPage } from "@/pages/social-post-planner";
import { LayoutTemplatesPage } from "@/pages/layout-templates";
import { InstagramDebugPage } from "@/pages/instagram-debug";
import { ImageRegenerationsPage } from "@/pages/image-regenerations";
import { ModelPricingPage } from "@/pages/model-pricing";
import { PaymentsPage } from "@/pages/payments";
import { ProductStatsPage } from "@/pages/product-stats";

const environmentNotchLabel = resolveEnvironmentNotchLabel(
  import.meta.env.VITE_APP_ENV,
  import.meta.env.DEV,
);

export default function App() {
  return (
    <BrowserRouter>
      <EnvironmentNotch label={environmentNotchLabel} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Navigate to="/brands" replace />} />
          <Route path="brands" element={<BrandsPage />} />
          <Route path="stats" element={<ProductStatsPage />} />
          <Route path="brands/:id" element={<BrandDetailsPage />} />
          <Route path="brands/:id/campaigns" element={<CampaignsPage />} />
          <Route path="brands/:id/campaigns/:campaignId" element={<CampaignDetailPage />} />
          <Route
            path="brands/:id/campaigns/:campaignId/planned-posts/:postId"
            element={<CampaignPlannedPostDetailPage />}
          />
          <Route path="social-post-planner" element={<SocialPostPlannerPage />} />
          <Route path="carousel-formats" element={<CarouselFormatsPage />} />
          <Route path="layout-templates" element={<LayoutTemplatesPage />} />
          <Route path="brands/:id/social-post-planner" element={<SocialPostPlannerPage />} />
          <Route path="instagram-debug" element={<InstagramDebugPage />} />
          <Route path="calendar" element={<CalendarOpsPage />} />
          <Route path="release-access" element={<ReleaseAccessPage />} />
          <Route path="runtime-flags" element={<RuntimeFlagsPage />} />
          <Route path="runtime-flags/:groupSlug" element={<RuntimeFlagsPage />} />
          <Route path="model-pricing" element={<ModelPricingPage />} />
          <Route path="image-regenerations" element={<ImageRegenerationsPage />} />
          <Route path="runs" element={<RunsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailsPage />} />
          <Route path="workspaces" element={<WorkspacesPage />} />
          <Route path="workspaces/:id" element={<WorkspaceDetailsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="billing-plans" element={<BillingPlansPage />} />
          <Route path="credit-packs" element={<CreditPacksPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/brands" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
